module.exports = __webpack_public_path__ + "img/reserve_banner.5bf2c7e1.png";